import i18n from 'i18next';

export default (model) => ({
  actions: [
    { action: 'cancel', text: i18n.t('cancel', 'Cancel'), variant: 'ghost' },
    { action: 'submit', color: 'brand', text: i18n.t('save', 'Save') },
  ],
  hasCloseButton: true,
  model,
  schema: {
    href: { type: 'Text', label: i18n.t('url', 'URL') },
    text: { type: 'Text', label: i18n.t('display-text', 'Display Text') },
    target: {
      type: 'Select',
      label: i18n.t('target', 'Target'),
      options: [
        { label: i18n.t('none', 'None'), value: '_self' },
        { label: i18n.t('new-tab', 'New Tab'), value: '_blank' },
      ],
    },
  },
  title: i18n.t('link', 'Link'),
});
